import React, { useRef, memo } from "react"
import { Typography, useTheme } from "@material-ui/core"
import Icon from "common/components/Icon"
import tableExpand from "../../../assets/table_expand.svg"
import Clickable from "../../Clickable"

const TrendingTopicBar = memo(({ party, value, percent, right, textInside }) => {
  const theme = useTheme()
  const ref = useRef(null)
  const displayValue = value?.toFixed(2)

  const color = theme.palette[party].main
  const darkColor = theme.palette[party].dark
  const gradient = `repeating-linear-gradient(60deg, ${color}, ${color} 8px, ${darkColor} 8px, ${darkColor} 12px)`

  return (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: right ? "row-reverse" : "row",
        justifyContent: "flex-end",
      }}
    >
      {!textInside && (
        <Typography
          style={{
            fontSize: 16,
            color: theme.palette[party].main,
            fontWeight: 700,
            margin: "0 10px",
          }}
        >
          {displayValue}
        </Typography>
      )}
      <div
        ref={ref}
        style={{
          background: value < 0 ? gradient : color,
          height: 28,
          borderRadius: right ? "0 4px 4px 0" : "4px 0 0 4px",
          width: `${percent}%`,
          padding: "2px 8px",
          overflow: "auto",
          textAlign: right ? "left" : "right",
        }}
      >
        {textInside && (
          <Typography style={{ fontSize: 16, color: "#FFFFFF", fontWeight: 700 }}>
            {displayValue}
          </Typography>
        )}
      </div>
    </div>
  )
})

const TrendingTopicRow = ({ label, values, maxValues, id, width, onClick }) => {
  const minSpace = 52

  const barSpace = (width - 16 - 150) / 2

  const demoVal = Math.abs(
    maxValues.democrat === 0 ? 0 : (values.democrat || 0) / maxValues.democrat,
  )
  const repVal = Math.abs(
    maxValues.republican === 0 ? 0 : (values.republican || 0) / maxValues.republican,
  )

  const handleClick = evt => {
    if (onClick) {
      onClick(id, evt)
    }
  }

  return (
    <Clickable
      style={{
        display: "flex",
        padding: 8,
        alignItems: "center",
        cursor: onClick ? "pointer" : "inherit",
      }}
      onClick={handleClick}
    >
      <TrendingTopicBar
        party="democrat"
        value={values.democrat || 0}
        percent={demoVal * 100}
        textInside={barSpace * demoVal > minSpace}
      />
      <div
        style={{
          flex: 0,
          padding: "0 8px",
          display: "flex",
          alignItems: "center",
          minWidth: 135,
        }}
      >
        <Typography
          style={{
            margin: "0 5px",
            width: 110,
            fontSize: 14,
            fontWeight: 700,
            textAlign: "center",
            lineHeight: "16px",
          }}
        >
          {label}
        </Typography>
        {onClick && (
          <Icon src={tableExpand} height={12} style={{ height: 12, transform: "rotate(-90deg)" }} />
        )}
      </div>
      <TrendingTopicBar
        party="republican"
        value={values.republican || 0}
        percent={repVal * 100}
        right
        textInside={barSpace * repVal > minSpace}
      />
    </Clickable>
  )
}

export default memo(TrendingTopicRow)
